// Phase 10d-6b — operator escalation admin schemas.
//
// Two endpoints:
//   POST /admin/shifts/:id/record-manual-payment   (10d-6b "call to pay")
//   POST /admin/payment-events/refund               (10d-6b refund-on-cancel)
//
// MANUAL_PAID is the resulting shift state for the record path;
// refund creates a STRIPE_REFUND or negative MANUAL_CREDIT PaymentEvent
// depending on the original mechanic.
import { z } from 'zod';
const ReasonSchema = z
    .string()
    .min(10, 'Operator note must be at least 10 characters')
    .max(500);
const RefundReasonSchema = z
    .string()
    .min(10, 'Refund reason must be at least 10 characters')
    .max(500);
export const ManualPaymentMechanicSchema = z.enum([
    'STRIPE_DIRECT_CHARGE',
    'CHEQUE',
    'EFT',
    'E_TRANSFER',
]);
export const RecordManualPaymentRequestSchema = z
    .object({
    mechanic: ManualPaymentMechanicSchema,
    amountCents: z.number().int().positive(),
    externalRef: z.string().min(1).max(120),
    stripePaymentMethodId: z
        .string()
        .regex(/^pm_[A-Za-z0-9]+$/, 'Stripe PaymentMethod ids start with pm_')
        .optional(),
    operatorNote: ReasonSchema,
})
    .refine((v) => v.mechanic !== 'STRIPE_DIRECT_CHARGE' || v.stripePaymentMethodId !== undefined, {
    message: 'stripePaymentMethodId is required when mechanic = STRIPE_DIRECT_CHARGE',
    path: ['stripePaymentMethodId'],
});
export const RecordManualPaymentResponseSchema = z.object({
    shiftId: z.string().uuid(),
    invoiceId: z.string().uuid().nullable(),
    paymentEventId: z.string().uuid(),
    preAuthStatus: z.literal('MANUAL_PAID'),
});
export const RefundPaymentRequestSchema = z.object({
    invoiceId: z.string().uuid(),
    amountCents: z.number().int().positive(),
    reason: RefundReasonSchema,
});
export const RefundPaymentResponseSchema = z.object({
    paymentEventId: z.string().uuid(),
    invoiceId: z.string().uuid(),
    amountCents: z.number().int().negative(),
    mechanic: z.enum(['STRIPE_REFUND', 'MANUAL_CREDIT']),
});
//# sourceMappingURL=operator-payment-admin.schema.js.map